/* ORO EVOO coming soon — vanilla JS port of v2.jsx
   Tuscany live clock, V2 horizontal pinned scroll, Klaviyo subscribe hook. */

(function () {
  'use strict';

  // Mobile viewport unit fix. Prefer visualViewport when available so the
  // value follows iOS Safari URL bar collapse/expand. Falls back to
  // innerHeight on older browsers.
  function setVh() {
    var h = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
    document.documentElement.style.setProperty('--vh', (h * 0.01) + 'px');
  }
  setVh();
  window.addEventListener('resize', setVh, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', setVh, { passive: true });
  }

  // Pill position is now CSS-only (top on desktop, bottom on mobile).

  // Tuscany clock, Europe/Rome, 12h with seconds
  var clockEl = document.querySelector('[data-clock]');
  if (clockEl) {
    var fmt = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Rome', hour12: true,
      hour: 'numeric', minute: '2-digit', second: '2-digit'
    });
    function tickClock() {
      clockEl.textContent = fmt.format(new Date()).replace(/ /g, ' ');
    }
    tickClock();
    setInterval(tickClock, 1000);
  }

  // V2 gallery. Two scroll modes:
  //   Desktop: vertical body scroll → JS translates the horizontal track (pinned).
  //   Mobile : native horizontal scroll on the pin container, body is locked.
  //            (Avoids iOS Safari URL bar collapse jitter entirely.)
  var wrap = document.querySelector('[data-v2]');
  var pin = document.querySelector('[data-v2-pin]');
  var track = document.querySelector('[data-v2-track]');
  var progressEl = document.querySelector('[data-v2-progress]');
  var progressLabel = document.querySelector('[data-v2-progress-label]');

  function updateProgress(p) {
    if (progressEl) progressEl.style.setProperty('--p', Math.round(p * 100) + '%');
    if (progressLabel) {
      progressLabel.textContent = String(Math.round(p * 100)).padStart(3, '0') + ' / 100';
    }
  }

  // Centered-card detection: the card whose horizontal center is closest to
  // the viewport center gets .is-centered (drives the B&W -> colour fade).
  // Works in both desktop (translate) and mobile (native scroll) modes since
  // getBoundingClientRect reflects whatever positioning is active.
  var cards = track ? track.querySelectorAll('.v2-card') : [];
  var lastCenteredCard = null;
  function updateCenteredCard() {
    if (!cards.length) return;
    var vw = window.innerWidth;
    var center = vw / 2;
    var best = null;
    var bestDist = Infinity;
    for (var i = 0; i < cards.length; i++) {
      var r = cards[i].getBoundingClientRect();
      // Skip if the card is entirely off-screen (avoids "winning" by being
      // closest while not visible at all).
      if (r.right < 0 || r.left > vw) continue;
      var c = r.left + r.width / 2;
      var d = Math.abs(c - center);
      if (d < bestDist) { bestDist = d; best = cards[i]; }
    }
    // Only colour when the centered element is genuinely close to center —
    // i.e. roughly within a card-half-width. Avoids fading a card in just
    // because it's the nearest while a text panel actually owns the centre.
    if (best) {
      var br = best.getBoundingClientRect();
      if (bestDist > br.width * 0.45) best = null;
    }
    if (best === lastCenteredCard) return;
    if (lastCenteredCard) lastCenteredCard.classList.remove('is-centered');
    if (best) best.classList.add('is-centered');
    lastCenteredCard = best;
  }

  var mobileMQ = window.matchMedia('(max-width: 760px)');
  var teardown = null;

  function attachDesktop() {
    if (!wrap || !pin || !track) return function () {};
    // Reset any mobile-mode state in case we just resized in.
    pin.scrollLeft = 0;
    track.style.transform = '';

    function measure() {
      var trackW = track.scrollWidth;
      var vw = window.innerWidth;
      var travel = Math.max(0, trackW - vw);
      wrap.style.height = (travel + window.innerHeight) + 'px';
    }

    var raf = 0;
    function tick() {
      raf = 0;
      var r = wrap.getBoundingClientRect();
      var vh = window.innerHeight;
      var total = wrap.offsetHeight - vh;
      var scrolled = Math.max(0, Math.min(total, -r.top));
      var p = total > 0 ? scrolled / total : 0;
      var trackW = track.scrollWidth;
      var vw = window.innerWidth;
      var travel = Math.max(0, trackW - vw);
      track.style.transform = 'translate3d(' + (-travel * p) + 'px, 0, 0)';
      updateProgress(p);
      updateCenteredCard();
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(tick); }
    function onResize() { measure(); tick(); }

    // Directional snap: when vertical scroll settles, advance one panel in
    // the direction of travel since the last anchor (never bounce back).
    // The snap drives the OUTER vertical scroll, so it stays in sync with
    // the pin/translate. Snaps to any track child (text panels + photo cards).
    var snapTimer = 0;
    var snapping = false;
    var snapAnchorY = null;
    var snapAnchorIdx = -1;
    function panelTargetY(el) {
      var vw = window.innerWidth;
      var trackW = track.scrollWidth;
      var travel = Math.max(0, trackW - vw);
      if (travel <= 0) return null;
      // br.left - tr.left is layout offset within the track; both rects
      // reflect the same transform, so the difference is transform-free.
      var tr = track.getBoundingClientRect();
      var br = el.getBoundingClientRect();
      var centerInTrack = (br.left - tr.left) + br.width / 2;
      var p = (centerInTrack - vw / 2) / travel;
      p = Math.max(0, Math.min(1, p));
      var total = wrap.offsetHeight - window.innerHeight;
      return wrap.offsetTop + p * total;
    }
    function currentCenteredIndex() {
      var vw = window.innerWidth;
      var viewportCenter = vw / 2;
      var best = -1;
      var bestDist = Infinity;
      for (var i = 0; i < track.children.length; i++) {
        var r = track.children[i].getBoundingClientRect();
        var c = r.left + r.width / 2;
        var d = Math.abs(c - viewportCenter);
        if (d < bestDist) { bestDist = d; best = i; }
      }
      return best;
    }
    function scheduleSnap() {
      if (snapping) return;
      var y = window.scrollY || window.pageYOffset;
      // First scroll event of a fresh gesture: capture anchor position
      // AND the panel index that was centered before the user touched it.
      if (snapAnchorY == null) {
        snapAnchorY = y;
        snapAnchorIdx = currentCenteredIndex();
      }
      if (snapTimer) clearTimeout(snapTimer);
      snapTimer = setTimeout(function () {
        var nowY = window.scrollY || window.pageYOffset;
        var delta = nowY - snapAnchorY;
        if (Math.abs(delta) < 12 || snapAnchorIdx < 0) {
          snapAnchorY = null; snapAnchorIdx = -1; return;
        }
        var dir = delta > 0 ? 1 : -1;
        // Among panels strictly in the direction of travel from the anchor,
        // pick the one whose target Y is closest to where the user actually
        // scrolled. Tiny scroll lands on the immediate neighbour; scrolling
        // all the way to the top/bottom lands on the boundary panel.
        var ty = null;
        var bestDist = Infinity;
        var first = dir > 0 ? snapAnchorIdx + 1 : 0;
        var last  = dir > 0 ? track.children.length - 1 : snapAnchorIdx - 1;
        for (var i = first; i <= last; i++) {
          var cy = panelTargetY(track.children[i]);
          if (cy == null) continue;
          var d = Math.abs(cy - nowY);
          if (d < bestDist) { bestDist = d; ty = cy; }
        }
        if (ty == null || Math.abs(ty - nowY) < 2) {
          snapAnchorY = null; snapAnchorIdx = -1; return;
        }
        snapping = true;
        // Custom rAF easing so the snap is noticeably slower / more graceful
        // than the browser's native smooth-scroll.
        var startY = nowY;
        var dy = ty - startY;
        var dur = 1100;
        var t0 = performance.now();
        function easeInOutCubic(x) {
          return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
        }
        function step(now) {
          var t = Math.min(1, (now - t0) / dur);
          window.scrollTo(0, startY + dy * easeInOutCubic(t));
          if (t < 1) requestAnimationFrame(step);
          else {
            snapping = false;
            snapAnchorY = null;
            snapAnchorIdx = -1;
          }
        }
        requestAnimationFrame(step);
      }, 280);
    }

    measure();
    tick();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', scheduleSnap, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });

    var imgs = track.querySelectorAll('img');
    var imgHandlers = [];
    imgs.forEach(function (img) {
      if (img.complete) return;
      var h = function () { onResize(); };
      img.addEventListener('load', h, { once: true });
      imgHandlers.push([img, h]);
    });

    return function detach() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('scroll', scheduleSnap);
      window.removeEventListener('resize', onResize);
      if (raf) cancelAnimationFrame(raf);
      if (snapTimer) clearTimeout(snapTimer);
      imgHandlers.forEach(function (pair) { pair[0].removeEventListener('load', pair[1]); });
      wrap.style.height = '';
      track.style.transform = '';
    };
  }

  function attachMobile() {
    if (!pin) return function () {};
    // Reset any desktop-mode state in case we just resized in.
    wrap.style.height = '';
    track.style.transform = '';

    var raf = 0;
    function tick() {
      raf = 0;
      var max = pin.scrollWidth - pin.clientWidth;
      var p = max > 0 ? pin.scrollLeft / max : 0;
      updateProgress(p);
      updateCenteredCard();
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(tick); }

    tick();
    pin.addEventListener('scroll', onScroll, { passive: true });

    return function detach() {
      pin.removeEventListener('scroll', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }

  function applyMode() {
    if (teardown) { teardown(); teardown = null; }
    teardown = mobileMQ.matches ? attachMobile() : attachDesktop();
  }
  applyMode();
  if (mobileMQ.addEventListener) {
    mobileMQ.addEventListener('change', applyMode);
  } else if (mobileMQ.addListener) {
    mobileMQ.addListener(applyMode);
  }

  // Subscribe buttons (pill at top + Waitlist button on the stamp panel)
  // -> Klaviyo onsite form QYQyys via the onsite.js queue.
  function openWaitlist() {
    try {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'QYQyys']);
    } catch (e) {
      if (window.console) console.warn('Klaviyo openForm failed', e);
    }
  }
  document.querySelectorAll('[data-subscribe]').forEach(function (btn) {
    btn.addEventListener('click', openWaitlist);
  });

  // "You're on the list" state.
  // Persists per-device in localStorage. When the visitor submits the
  // Klaviyo form (klaviyoForms event, type=submit), we flag the device
  // and hide the waitlist CTAs on this and future visits.
  function isWaitlisted() {
    try { return localStorage.getItem('oro_waitlisted') === '1'; }
    catch (e) { return false; }
  }
  function markWaitlisted() {
    try { localStorage.setItem('oro_waitlisted', '1'); } catch (e) {}
    document.body.classList.add('is-waitlisted');
  }
  if (isWaitlisted()) {
    document.body.classList.add('is-waitlisted');
  }
  window.addEventListener('pageshow', function () {
    if (isWaitlisted()) document.body.classList.add('is-waitlisted');
  });

  // Submit detection via klaviyoForms event (window + document; SDK
  // dispatches differ across versions). Only mark waitlisted on actual
  // submit / success events, never on open or embed.
  function onKlaviyoEvent(e) {
    if (!e || !e.detail) return;
    var t = e.detail.type;
    if (t === 'submit' || t === 'success' || t === 'redirected' || t === 'redirect') {
      markWaitlisted();
    } else if (t === 'stepSubmit' && e.detail.metaData && e.detail.metaData.isFinalStep) {
      markWaitlisted();
    }
  }
  window.addEventListener('klaviyoForms', onKlaviyoEvent);
  document.addEventListener('klaviyoForms', onKlaviyoEvent);
})();
